// import React from 'react';
import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';
import { getUserId } from '../../localStorages';

export default data => {
  const newData = data;
  newData.userId = getUserId() || newData.userId || null;
  const dataCreate = parseToMutationRequest(newData, ['status']);
  const createCollectionUnit = `createCollectionUnit(input: ${dataCreate})`;
  return gql`
  mutation {
    ${createCollectionUnit} {
      id
      userId
      accountId
      invoiceId
      invoiceDate
      dueDate
      lastActionDate
      notes
      closeDate
      daysInCollection
      status
      unitActionList {
        index
        description
        action
        date
      }
    }
  }
`;
};
